<template>
  <v-card class="text-xs-center elevation-5 mx-2">
    <p class="green darken-3 white--text py-1 ">
      <slot name="header"/>
    </p>
    <p class="py-3">
      <slot/>
    </p>
  </v-card>
</template>

<script>
export default {

}
</script>
